import { render, staticRenderFns } from "./SigninStep.vue?vue&type=template&id=5bbf87b5&"
import script from "./SigninStep.vue?vue&type=script&lang=js&"
export * from "./SigninStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports